import { useStaticQuery, graphql } from 'gatsby';
import React from 'react';
import Section, { themes } from '../UI/Section/Section';
import { GridItem, GridReveal } from '../UI/Grid/Grid';
import Type from '../UI/Type/Type';
import Teaser from '../UI/Teaser/Teaser';
import LocationCard from '../LocationCard/LocationCard';

const LOCATIONS_QUERY = graphql`
  query LocationListerQuery {
    wp {
      acfOptionsCommonBlocks {
        common {
          locationLister {
            heading
            description
          }
        }
      }
    }
    allLocations: allWpLocation {
      nodes {
        id
        title
        uri: uriRedirect
        locationDetails {
          address
          telephone
          gallery {
            ...WpImage
          }
        }
      }
    }
  }
`;

const LocationLister = ({ ...other }) => {
  const {
    wp: {
      acfOptionsCommonBlocks: {
        common: { locationLister },
      }
    },
    allLocations
  } = useStaticQuery(LOCATIONS_QUERY);

  return (
    <Section {...other} theme={themes.DEFAULT} id="locations">
      <GridReveal staggerChildren>
        <GridItem lg={4}>
          <Teaser>
            Find us
          </Teaser>
          <Type.H2>{locationLister.heading}</Type.H2>
          <p>{locationLister.description}</p>
        </GridItem>
        <GridItem lg={8} justify="right">
          <GridReveal isBordered staggerChildren>
            {allLocations.nodes.map(({
              id,
              title,
              uri,
              locationDetails: { address, telephone, gallery },
            }) => (
              <GridItem md={4} key={id}>
                <LocationCard
                  title={title}
                  path={uri}
                  address={address}
                  telephone={telephone}
                  image={gallery[ 0 ]}
                  isPrimary
                  />
              </GridItem>
            ))}
          </GridReveal>
        </GridItem>
      </GridReveal>
    </Section>
  );
};

export default LocationLister;
